<template>
  <div class="homeentertainment">
    <div class="comp-title">
      <div class="left">
        <h1 class="text-uppercase color-text-bold">
          <img src="../../../../static/img/comp-title.png"/>
          TIN TỨC
        </h1>
      </div>

      <div class="right">
        <pagination
          :total-pages="totalPage"
          :total="totalRecord"
          :per-page="pageSize"
          :current-page="currentPage"
          @pagechanged="onPageChange"
          :previous-name="previousName"
          :next-name="nextName"
        >
        </pagination>
      </div>
    </div>
    <div style="clear: both"></div>

    <ul class="nav nav-tabs nav-custom" role="tablist">
      <li class="nav-item" v-for="(item, i) in subCategoryList.slice(0,4)">
        <a class="nav-link text-uppercase color-text" :class="{ active : i==0 }" data-toggle="tab" :data-target="'#' + item.subCategoryCode" @click="currentSubCategory=item.subCategoryCode">{{ item.name }}</a>
      </li>
    </ul>

    <!-- Tab panes -->
    <div class="tab-content">
      <div v-for="(item, i) in subCategoryList" :id="item.subCategoryCode" class="tab-pane" :class="{ active : i==0 }"><br>
        <div v-if="dataList.length == 0">
          <p>Chưa có dữ liệu!</p>
        </div>

        <div class="col-md-4 float-left featured p-0 position-relative" v-for="item in dataList.slice(0,1)">
          <a :href="checkLogin(loginRequest) == true ? prefixUrl + item.id + '/' + item.alias : 'javascript:void(0)'"
             :title="item.title"
             @click="redirectTo(checkLogin(loginRequest))">
            <img class="thumbnail" :src="item.thumbnail != '' ? item.thumbnail : defaultThumbnail" />
            <div class="caption position-absolute">
              <h4 class="song color-white">{{ subString(item.title, 70) }}</h4>
              <p class="singer color-blue text-right mb-0">Đọc tiếp <span class="fa fa-angle-double-right"></span></p>
            </div>
          </a>
        </div>

        <div class="col-md-8 float-right entertainment-normal pr-0">
          <div class="row">
            <div class="col-md-6 position-relative mb-3" v-for="item in dataList.slice(1,5)">
              <a :href="checkLogin(loginRequest) == true ? prefixUrl + item.id + '/' + item.alias : 'javascript:void(0)'"
                 :title="item.title"
                 @click="redirectTo(checkLogin(loginRequest))">
                <img :src="item.thumbnail != '' ? item.thumbnail : defaultThumbnail" class="img-w-60 float-left mr-2"/>
                <h4 class="song color-text">{{ subString(item.title, 55) }}</h4>
                <p class="singer color-blue text-right">Đọc tiếp <span class="fa fa-angle-double-right"></span></p>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Pagination from '../../Pagination'
  export default {
    name: "Entertainment",
    components: {
      "pagination": Pagination
    },
    props:{
      loginRequest: String
    },
    data () {
      return {
        currentSubCategory: "",
        pageSize: 4,
        currentPage: 1,
        totalRecord: 1,
        totalPage: 1,
        previousName: "previousArrow",
        nextName: "nextArrow",
        dataList: [],

        subCategoryList: [],
        prefixUrl: this.settings.prefixNews,
        defaultThumbnail: this.settings.defaultThumbnailBigSong
      }
    },
    methods:{
      getSubCategoryList(){
        axios.post(api.subCategoryByCategory, { categoryCode: "TT" })
          .then(response => {
            this.subCategoryList = response.data.result;
            return this.subCategoryList[0].subCategoryCode;
          })
          .then(response => {
            this.currentSubCategory = response;
            this.getDataList();
          })
          .catch(e => {
            console.log("EntertainmentSubCategory---");
            console.log(e);
          });
      },
      getDataList(){
        var dataPost = {
          "subCategoryCode": this.currentSubCategory,
          "pageSize": 5,
          "pageIndex": this.currentPage
        };
        axios.post(api.newsListBySubCategory, dataPost)
          .then(response => {
            this.dataList = response.data.result;
            this.totalRecord = response.data.totalRecord;
            this.totalPage = response.data.totalPage;
          }).catch(error => {
          console.log(error);
        });
      },
      onPageChange(page){
        this.currentPage = page;
      }
    },
    watch: {
      "currentPage": {
        handler: "getDataList",
      },
      "currentSubCategory": function (val) {
        this.getDataList();
        this.currentPage = 1;
      },
      "$route.path": {
        handler: function (val) {
          this.getSubCategoryList();
        },
        immediate: true
      }
    }
  }
</script>

<style scoped>
  .homeentertainment{
    margin-top: 30px;
    text-align: left;
  }
  .nav-custom .nav-item{
    width: calc(100%/4);
  }
  .song{
    padding-top: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/entertainment/web/News.vue